// extracted by mini-css-extract-plugin
module.exports = {"cover":"BoardCover_cover__wW4Ay","coverItem":"BoardCover_coverItem___ymAY"};